<template>
  <div :class="{ disabled: isSaving }">
    <div class="mb-3" style="display: flex; justify-content: space-between">
      <div style="display: flex">
        <h2 class="pt-2">Filters{{ selectedFilter() ? ' - ' + selectedFilter().name : '' }}</h2>
        <v-tooltip top v-if="filterSnapshotChanged()">
          <span style="font-size: 24px; color: red" slot="activator">*</span>
          <span>Unsaved filters.</span>
        </v-tooltip>
      </div>
      <div>
        <v-menu v-model="menu" bottom left origin="top right" style="z-index: 1001">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="my-1 mx-2" flat icon v-bind="attrs" v-on="on" @click.stop.prevent>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list class="pb-0">
            <v-list-tile>
              <v-list-tile-sub-title>Filters Store</v-list-tile-sub-title>
            </v-list-tile>
          </v-list>
          <v-list class="py-0 px-2">
            <v-list-tile @click="selectedFilterId = (selectedFilter() || {}).uuid">
              <v-list-tile-title><v-icon class="pr-2">mdi-folder-open-outline</v-icon>Load</v-list-tile-title>
            </v-list-tile>
          </v-list>
          <v-list class="py-0 px-2">
            <v-list-tile @click="saveFilterName = (selectedFilter() || {}).name">
              <v-list-tile-title><v-icon class="pr-2">mdi-content-save-outline</v-icon>Save As</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </div>

    <hvh-modal :value="true" title="Load filter" @input="selectedFilterId = null" v-if="selectedFilterId !== null">
      <template v-slot>
        <v-select :items="items" v-model="selectedFilterId" item-text="name" item-value="uuid" label="Select Filter" outline />
      </template>
      <template v-slot:actions>
        <v-btn flat="flat" @click="selectedFilterId = null">Cancel</v-btn>
        <v-btn flat="flat" @click="changeFilter(selectedFilterId)">Load</v-btn>
      </template>
    </hvh-modal>

    <hvh-modal :value="true" title="Save filter" @input="saveFilterName = null" v-if="saveFilterName !== null">
      <template v-slot>
        <v-text-field label="Name" v-model="saveFilterName" />
      </template>
      <template v-slot:actions>
        <v-btn flat="flat" @click="saveFilterName = null">Cancel</v-btn>
        <v-btn flat="flat" @click="save">Save</v-btn>
      </template>
    </hvh-modal>
  </div>
</template>

<script>
import axios from '../../../axios';
import { hashCode } from '../../../libraries/common';
export default {
  noExport: true,
  props: ['value', 'segment', 'runId', 'items', 'filterSnapshot'],
  data: () => ({ menu: false, selectedFilterId: null, saveFilterName: null, isSaving: false, }),
  methods: {
    changeRouteId(uuid) {
      var url = (new URL(document.location));
      url.searchParams.set('filterId', uuid);
      url.searchParams.delete('filterSnapshotId');
      window.history.replaceState(null, null, url.href);
    },
    changeFilter(uuid) {
      this.changeRouteId(uuid);

      var filter = this.items.find(f => f.uuid == uuid);
      this.$emit('input', JSON.parse(filter.filter));

      this.selectedFilterId = null;
    },
    save() {
      this.isSaving = true;
      axios.post(`/Analytics/CohortAnalyticRun/${this.runId}/Filters`, { name: this.saveFilterName, filter: JSON.stringify(this.value) })
        .then(response => {
          this.changeRouteId(response.data.uuid);
          this.items.push(response.data);
          this.saveFilterName = null;
        })
        .catch(console.error)
        .then(() => this.isSaving = false);
    },
    selectedFilter() {
      var uuid = (new URL(document.location)).searchParams.get('filterId');
      return this.items.find(f => f.uuid === uuid);
    },
    hasFilterSnapshotId() {
      return (new URL(document.location)).searchParams.get('filterSnapshotId');
    },
    filterSnapshotChanged() {
      return this.hasFilterSnapshotId() && (hashCode(this.filterSnapshot) !== hashCode(this.value));
    },
  },
  mounted() {
    if (this.selectedFilter())
      this.changeFilter(this.selectedFilter().uuid);
  },
}
</script>